import React, { useState } from "react";
import Header from "../../components/Header/Header";
import "./EcommerceWishlist.scss"
import ItemComponent from "../../components/ItemComponent/ItemCopmonent";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setWishlist } from "../../../../../../../redux/companyDataSlice";
import Button from "../../components/Button/Button";

const EcommerceWishlist = () => {

    const history = useHistory()
    const wishlist = useSelector((state) => state.companyData.wishlist)
    const dispatch = useDispatch()
    const onClose = (item) => {
        const updated = wishlist.filter((product) => product.ProductID !== item.ProductID)
        dispatch(setWishlist(updated))
    }
    return (
        <div className="EcommerceWishlist">
            <div className="EcommerceWishlist-header"><Header text={"Wislist"} textAlign="center" /></div>
            {wishlist.length > 0 ? <div className="EcommerceWishlist-Container">
                {wishlist.map((product, key) => {
                    return (
                        <ItemComponent key={key} item={product} layout={"layout2"}
                            onClick={() => {
                                history.push(`/product/${product.ProductID}`)
                            }} isClose onClose={() => { onClose(product) }} />
                    )
                })}

            </div> : <div className="EcommerceWishlist-emptyContainer">
                <div className="Ecom-Wish-empty">
                    <div className="wish-empty-header">Your wishlist is empty</div>
                    <div className="wish-empty-subheader">You haven’t Saved anything yet.</div>
                    <Button text={"Start Explore"} invert width={"100%"}
                        onClick={() => {
                            history.push("/")
                        }} />
                </div>
            </div>}
        </div>
    )
}
export default EcommerceWishlist